export default __webpack_public_path__ + "static/media/golo-table.7cc978ef.webp";